import { render, staticRenderFns } from "./NotificationsNew.vue?vue&type=template&id=1569837a&lang=html&"
import script from "./NotificationsNew.vue?vue&type=script&lang=js&"
export * from "./NotificationsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports